/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_traffic_event__lane_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Verengung`
};

const en_traffic_event__lane_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Shrinkage`
};

const es_traffic_event__lane_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Contracción`
};

const fr_traffic_event__lane_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Rétrécissement`
};

const it_traffic_event__lane_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Restringimento`
};

const nl_traffic_event__lane_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Krimp`
};

const pt_traffic_event__lane_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Retração`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__lane_closed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.traffic_event__lane_closed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("traffic_event__lane_closed", locale)
	if (locale === "de") return de_traffic_event__lane_closed(inputs)
	if (locale === "en") return en_traffic_event__lane_closed(inputs)
	if (locale === "es") return es_traffic_event__lane_closed(inputs)
	if (locale === "fr") return fr_traffic_event__lane_closed(inputs)
	if (locale === "it") return it_traffic_event__lane_closed(inputs)
	if (locale === "nl") return nl_traffic_event__lane_closed(inputs)
	return pt_traffic_event__lane_closed(inputs)
};